import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { DEFAULT_LLM_MODEL_KEY } from '../const/llm-model-options'

interface LlmModelState {
  /** 선택된 모델 키 (llm-model-options의 key) */
  selectedModelKey: string
  setSelectedModelKey: (key: string) => void
}

/**
 * LLM 모델 선택 상태
 *
 * localStorage에 저장되어 새로고침해도 선택이 유지된다.
 */
export const useLlmModelStore = create<LlmModelState>()(
  persist(
    (set) => ({
      selectedModelKey: DEFAULT_LLM_MODEL_KEY,
      setSelectedModelKey: (key) => set({ selectedModelKey: key }),
    }),
    {
      name: 'llm-model-selection',
    }
  )
)
